// home-search.js — ORQUESTADOR: conecta módulos con el DOM
import { getSuggestionsContainer, limpiarSugerencias, buscarSugerencias, findExactBizMatch } from './home-search/suggestions.js';
import { createCitySuggestions } from './home-search/city-suggestions.js';
import { createUseLocationButton } from './home-search/geolocation.js';
import { isPremium } from './home-search/premium-detector.js';
import { openPremiumWindowForBusiness } from './home-search/premium-card.js';
import { navigateToBizContext } from './home-search/utils.js';
import { initSearchFlow, hacerBusqueda } from './home-search/search-flow.js';

// DOM refs
const inputBusqueda = document.querySelector('.search-card input[type="text"]');
const selectCategoria = document.querySelector('.search-card select');
const inputCiudad = document.querySelectorAll('.search-card input[type="text"]')[1];
const btnBuscar = document.querySelector('.search-card-btn');

// Prefill ciudad
try { const c = localStorage.getItem('user_city'); if (c && inputCiudad && !inputCiudad.value) inputCiudad.value = c; } catch(_){}

// Sugerencias de ciudad
let citySuggestions = null;
if (inputCiudad) citySuggestions = createCitySuggestions(inputCiudad);

// Botón ubicación
createUseLocationButton(inputCiudad);

// Sugerencias de búsqueda + cerrar al hacer click fuera
let contenedorSugerencias = null;
if (inputBusqueda) {
  contenedorSugerencias = getSuggestionsContainer(inputBusqueda);
  initSearchFlow(inputBusqueda, inputCiudad);
  inputBusqueda.addEventListener('input', buscarSugerencias(inputBusqueda, inputCiudad));
  document.addEventListener('click', (e) => {
    if (contenedorSugerencias && !contenedorSugerencias.contains(e.target) && e.target !== inputBusqueda) limpiarSugerencias();
  });
}

// Botón buscar
if (btnBuscar) btnBuscar.addEventListener('click', hacerBusqueda);

// Enter en búsqueda
if (inputBusqueda) {
  inputBusqueda.addEventListener('keydown', (function(e) {
    if (e.key !== 'Enter') return;
    const exactBiz = findExactBizMatch((inputBusqueda.value || '').trim());
    try { console.log('🔎 [ENTER]', exactBiz ? 'exact match: '+exactBiz.name : 'sin exact match'); } catch(_){}
    if (exactBiz && isPremium(exactBiz)) { e.preventDefault(); openPremiumWindowForBusiness(exactBiz); return; }
    if (exactBiz && navigateToBizContext(exactBiz)) { e.preventDefault(); return; }
    hacerBusqueda();
  }));
}

// Categorías en filtro (diferido hasta interacción)
export async function cargarCategoriasEnFiltro() {
  try {
    if (!selectCategoria) return;
    const { fetchCategories } = await import('./categorias-api.js');
    selectCategoria.replaceChildren();
    const def = document.createElement('option'); def.value = ''; def.textContent = 'Seleccionar categoría';
    selectCategoria.appendChild(def);
    (await fetchCategories()).forEach(cat => {
      const opt = document.createElement('option'); opt.value = cat.slug; opt.textContent = cat.name;
      selectCategoria.appendChild(opt);
    });
  } catch (_) {
    if (!selectCategoria) return;
    selectCategoria.replaceChildren();
    const err = document.createElement('option'); err.value = ''; err.textContent = '(Sin categorías)';
    selectCategoria.appendChild(err);
  }
}
(function(){
  try {
    let done = false;
    const run = () => { if (done) return; done = true; try { cargarCategoriasEnFiltro(); } catch(_) {} try { ['pointerdown','touchstart','keydown','focusin'].forEach(ev => document.removeEventListener(ev, run, true)); } catch(_) {} };
    ['pointerdown','touchstart','keydown','focusin'].forEach(ev => document.addEventListener(ev, run, true));
    setTimeout(run, 15000);
  } catch(_) { try { setTimeout(() => cargarCategoriasEnFiltro(), 15000); } catch(__) {} }
})();

console.log('✅ home-search.js orquestador cargado');
